/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';

import Text from './Text';
import TextInput, { TextInputType, TextInputProps } from './TextInput';
import { themeColors } from './Constants';

type Props = Omit<TextInputProps, 'onFocus' | 'onBlur'> & {
  errorMessage?: string | null | undefined;
  skipFirstCheck?: boolean;
  checkError?: (input: string) => boolean;
  inputLimit?: number;
  containerStyle?: StyleProp<ViewStyle>;
};

type State = {
  isFocused: boolean;
  /* Tracks if the user has interacted with this input at all (even just focused it) */
  isTouched: boolean;
};

export default class TextInputWithError extends Component<Props, State> {
  state: State = {
    isFocused: false,
    isTouched: false,
  };
  _ref = React.createRef<TextInputType>();

  render() {
    let {
      errorMessage,
      checkError,
      skipFirstCheck,
      containerStyle,
      inputLimit,
      value,
      style,
      ...otherProps
    } = this.props;
    let { isFocused, isTouched } = this.state;

    let isValid = checkError ? checkError(value ?? '') : true;
    let showError = skipFirstCheck && !isTouched ? false : !isValid;

    let boxShadow =
      showError && isFocused
        ? { boxShadow: ' 0px 0px  5px 1px #cf4343' }
        : undefined;
    const showUtils = inputLimit != null || showError;

    return (
      <View style={[styles.container, containerStyle]}>
        <TextInput
          {...otherProps}
          value={value}
          ref={this._ref}
          onFocus={() => {
            this.setState({ isFocused: true, isTouched: true });
          }}
          onBlur={() => {
            this.setState({ isFocused: false });
          }}
          style={[
            styles.textInput,
            boxShadow as any,
            showError && { borderColor: themeColors.red },
            style,
          ]}
        />
        <View>
          <View style={[styles.utilsStyle, !showUtils && { display: 'none' }]}>
            {errorMessage && showError && (
              <View style={styles.errorArea}>
                <Text style={styles.errorText}>{errorMessage}</Text>
              </View>
            )}

            {inputLimit && value ? (
              <View style={styles.counterArea}>
                <Text
                  style={styles.counterText}
                >{`${value.length}/${inputLimit}`}</Text>
              </View>
            ) : null}
          </View>
        </View>
      </View>
    );
  }

  focus() {
    this._ref.current && this._ref.current.focus();
  }
}

let styles = StyleSheet.create({
  textInput: {
    borderColor: themeColors.borderGrey,
    borderWidth: 1,
  },
  container: {
    flex: 1,
  },
  utilsStyle: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: 5,
    position: 'absolute',
    left: 0,
    right: 0,
  },
  errorText: {
    color: themeColors.red,
    fontSize: 12,
  },
  errorArea: {
    flex: 4,
    flexWrap: 'wrap',
  },
  counterText: {
    color: themeColors.darkGrey,
    fontSize: 12,
  },
  counterArea: {
    flex: 1,
    alignItems: 'flex-end',
  },
});
